import { API_URL } from 'config';
import { store } from 'store.js';
import { aggiornaPortafoglio, caricamento } from 'features/bi/biSlice';
import axios from 'axios';

const API_PORTAFOGLIO_URL = `${API_URL}/bi/get_bi/cliente/portafoglio/`;

const getPortafoglio = async (date) => {
  const data = date.split('-').reverse().join('/');

  store.dispatch(caricamento(true));

  const {
    auth: {
      currentUser: { pin, utente },
    },
  } = store.getState();

  try {
    const res = await axios.post(API_PORTAFOGLIO_URL, { utente, pin, data });
    const { successo = false, bi = [] } = res.data;

    if (!successo) throw new Error(JSON.stringify(res));
    store.dispatch(aggiornaPortafoglio(bi));
    store.dispatch(caricamento(false));
  } catch (e) {
    // eslint-disable-next-line no-alert
    alert('Unable to load data');
    console.log(e);
  }
};

export { getPortafoglio };
